import React from "react";

// reactstrap components
import {
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import AboutPageHeader from "components/Headers/AboutPageHeader.js";
// Import the new IndexFooter instead of DemoFooter
import IndexFooter from "components/Footers/IndexFooter.js";

function AboutPage() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("profile-page");
    };
  }, []);

  return (
    <>
      <IndexNavbar />
      <AboutPageHeader />      
      <br />
      <div className="main">
        <div className="section text-center">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" md="8">
                <h2 className="title">About Us</h2>
                <h5 className="description" style={{ textAlign: 'left' }}>
                  <strong>Homegrown. Handmade. Community Driven.</strong>
                  <br /><br />
                  Open every <strong>Wednesday and Saturday</strong> from <strong>Victoria Day Weekend to Thanksgiving, 9 AM to 1 PM</strong>, the Pembroke Farmers’ Market is your destination for fresh, local food and artisan products straight from the source.
                  <br /><br />
                  Meet the passionate producers and artisans of the Ottawa Valley who are proud to offer the quality and freshness you expect. From crisp vegetables and juicy fruits to farm-fresh eggs, pasture-raised meats, baked treats, preserves, maple syrup, and local honey — everything is proudly grown, raised, or made right here.
                  <br /><br />
                  For those seeking something handcrafted, our talented artisans bring soaps, candles, artwork, jewellery, and unique gifts that reflect the creativity of our region.
                  <br /><br />
                  <strong>Our Roots</strong><br />
                  The Market’s origins date back to the early 1900s, where it quickly became a cornerstone of Pembroke’s local economy. After a brief closure in the 1980s, the Market was successfully revived in 1992 through the combined efforts of a dedicated Vendors’ Association and the City of Pembroke. Since then, it has flourished as a welcoming space for community connection and commerce.
                  <br /><br />
                  One of our proudest milestones is the completion of a 5,000 square-foot covered pavilion in June 2007. Perfectly positioned by the waterfront, boardwalk, and downtown shops, this space offers a sheltered environment for vendors and visitors alike — complete with accessible washrooms, bike racks, a canteen, ice cream shop, and ample free parking.
                  <br /><br />
                  This facility was made possible by the generous support of the Ontario Trillium Foundation, the City of Pembroke, Farmers’ Markets Ontario, Giant Tiger Pembroke, Farm Credit Canada, and contributions from countless local individuals and businesses.
                  <br /><br />
                  We are proud to be a vital, vibrant part of Pembroke’s downtown — supporting local enterprise, fostering community spirit, and making it easier for shoppers to choose fresh and shop local.
                  <br /><br />
                  We look forward to welcoming you to the Market!
                </h5>
              </Col>
            </Row>
            <br />
            <br />
          </Container>
        </div>
      </div>
      {/* Use the new IndexFooter component */}
      <IndexFooter />
    </>
  );
}

export default AboutPage;